import React from "react";

import { IconProps } from "../../types/common";

const UploadIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#27A83B",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M18.125 8.9075C17.5583 6.10437 15.0333 4 12 4C9.59167 4 7.5 5.3325 6.45833 7.2825C3.95 7.5425 2 9.61438 2 12.125C2 14.8144 4.24167 17 7 17H17.8333C20.1333 17 22 15.18 22 12.9375C22 10.7925 20.2917 9.05375 18.125 8.9075ZM17.8333 15.375H7C5.15833 15.375 3.66667 13.9206 3.66667 12.125C3.66667 10.4594 4.94167 9.07 6.63333 8.89937L7.525 8.81L7.94167 8.03813C8.73333 6.55125 10.2833 5.625 12 5.625C14.1833 5.625 16.0667 7.13625 16.4917 9.22438L16.7417 10.4431L18.0167 10.5325C19.3167 10.6137 20.3333 11.6781 20.3333 12.9375C20.3333 14.2781 19.2083 15.375 17.8333 15.375ZM8.66667 11.3125H10.7917V13.75H13.2083V11.3125H15.3333L12 8.0625L8.66667 11.3125Z"
    />
  </svg>
);

export default UploadIcon;
